import { render, staticRenderFns } from "./NavigationList.vue?vue&type=template&id=b8f7d230&scoped=true&"
import script from "./NavigationList.vue?vue&type=script&lang=js&"
export * from "./NavigationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f7d230",
  null
  
)

export default component.exports